<template>
  <div class="bj-item-box">
    <div class="bj-item-info">
      <img
        class="bj-item-photo"
        :src="
          headerPhoto
            ? $global.imgUrl + headerPhoto
            : require('@/assets/img/mobile-img/default-photo.png')
        "
        alt=""
      />
      <div style="overflow: hidden">
        <h3 class="bj-item-name" v-html="name"></h3>
        <p class="bj-item-unit" v-html="unit"></p>
      </div>
    </div>
    <div v-show="research || number" class="bj-item-content">
      <div v-show="research" class="bj-item-research">
        研究方向：<span v-html="research"></span>
      </div>
      <div v-show="number">学术成果：<span v-html="number"></span></div>
    </div>
  </div>
</template>


<script>
export default {
  // 头像 名字 单位 研究方向 成果数量
  props: ["headerPhoto", "name", "unit", "research", "number"],
  data() {
    return {
      searchStr: "",
    };
  },
  computed: {
    // highLightName() {
    //   return this.name.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },
    /*
    highLightUnit() {
      return this.unit.replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
    highLightResearch() {
      return this.research.replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
    highLightNumber() {
      return (this.number + "").replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
    */
  },
  created() {
    // this.searchStr = this.$route.query.paramStr;
  },
};
</script>

<style scoped lang="scss">
.bj-item-box {
  .bj-item-info {
    display: flex;
    width: 100%;
    .bj-item-photo {
      margin-right: 12px;
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    .bj-item-name {
      margin-bottom: 8px;
      width: 100%;
      font-size: 15px;
      color: #333333;
      line-height: 21px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .bj-item-unit {
      width: 100%;
      font-size: 13px;
      color: #999999;
      line-height: 19px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .bj-item-content {
    margin-top: 15px;
    padding: 8px 10px;
    width: 100%;
    background: rgba(74, 121, 241, 0.1);
    border-radius: 6px;
    font-size: 13px;
    color: #666666;
    line-height: 19px;
    .bj-item-research {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>